export default theme => ({
  data: {
    marginTop: theme.sizes[3],
    width: "100%",
  },
  copyToClipboard: {
    width: "100%",
  },
});
